import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";
import type { QuickLoanApi } from "../@types";

const BASE = API_URL_V3 + "/alert/loan/quick-loans";

function useQuickLoan(
  loanId: string,
  options?: QueryObserverOptions<APIResponse<QuickLoanApi>, APIError>
) {
  const {
    isLoading: isLoadingLoan,
    isError: isLoanError,
    data: loanResponse,
    refetch: refetchLoan,
  } = useQuery<APIResponse<QuickLoanApi>, APIError>(
    ["quick-loan", loanId],
    async () => {
      const res = await get(BASE + "/" + encodeURIComponent(loanId), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      return res as APIResponse<QuickLoanApi>;
    },
    { enabled: !!loanId, ...options }
  );

  return {
    isLoadingLoan,
    isLoanError,
    loan: loanResponse?.data,
    loanResponse,
    refetchLoan,
  };
}

export default useQuickLoan;
